import Route from 'mewe/routes/route';

export default Route.extend({

  redirect(redir) {
    window.location.replace('https://support.mewe.com/hc/en-us')
  },
});
